// extracted by mini-css-extract-plugin
export var attachment = "promoted-items-attachment-module--attachment--1U1pp";
export var list = "promoted-items-attachment-module--list--2Abtz";